import { useState } from 'react';

const ProcessDueDateChangePopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showProcessDueDateChangePopup, setShowProcessDueDateChangePopup] =
      useState<boolean>(false);

    const processDueDateChangeToggleHandler = () => {
      setShowProcessDueDateChangePopup(!showProcessDueDateChangePopup);
    };

    return (
      <Component
        showProcessDueDateChangePopup={showProcessDueDateChangePopup}
        processDueDateChangeToggleHandler={processDueDateChangeToggleHandler}
        {...props}
      />
    );
  };

export default ProcessDueDateChangePopupHOC;
